import { message } from 'antd';
import { sendError } from './crashlytics';
import { I18n } from 'react-redux-i18n';

const GENERIC_ERROR = 'APPLICATION.ERRORS.GENERIC';

export function success (key) {
  return message.success(I18n.t(key ? key.toUpperCase() : GENERIC_ERROR));
}

export function warn (key) {
  return message.warn(I18n.t(key ? key.toUpperCase() : GENERIC_ERROR));
}

export function error (key, send) {
  const response = I18n.t(key ? key.toUpperCase() : GENERIC_ERROR);

  if (send) {
    sendError(response);
  }

  return message.error(response);
}
